import {
    Driver,
    DriverRelease,
    SensorDriverPackage,
} from '../types/driver_types.ts';

export const parseDriverList = async (driverList: Driver[]) => {
    const sensorDrivers = new Map<string, SensorDriverPackage>();

    for (const driver of driverList) {
        for (const sensor of driver.sensors) {
            if (sensorDrivers.has(sensor.name)) {
                sensorDrivers.get(sensor.name)?.drivers.push(driver);
                continue;
            }

            sensorDrivers.set(sensor.name, {
                sensorName: sensor.name,
                family: sensor.family,
                drivers: [driver],
            });
        }
    }

    const sortedDrivers = new Map(
        [...sensorDrivers.entries()].sort((a, b) =>
            a[0].localeCompare(b[0], undefined, {
                numeric: true,
                sensitivity: 'base',
            }),
        ),
    );

    return sortedDrivers;
};

export const isGithubLink = (url: string): boolean => {
    return (
        url.startsWith('https://github.com') ||
        url.startsWith('https://api.github.com')
    );
};

export const isGitlabLink = (url: string): boolean => {
    return url.startsWith('https://gitlab');
};

export const getLatestRelease = (driver: Driver): DriverRelease | undefined => {
    /**
     * Driver releases are sorted by ID, which is not necessarily the same order as the release date.
     */
    if (!driver.releases || driver.releases.length == 0) {
        return;
    }

    return driver.releases.reduce((latest, current) => {
        const latestDate = new Date(latest.release_date);
        const currentDate = new Date(current.release_date);
        return currentDate > latestDate ? current : latest;
    });
};

export const getLang = (): string => {
    if (navigator.languages && navigator.languages[0]) {
        return navigator.languages[0];
    }

    // fallback if no language preferences are given
    if (navigator.language) {
        return navigator.language;
    }

    // fallback to english if no user language is available
    return 'en';
};

export const formatDate = (date: string): string => {
    try {
        return new Date(date).toLocaleDateString(getLang(), {
            year: 'numeric',
            day: '2-digit',
            month: 'short',
        });
    } catch (error) {
        console.error('Failed to parse date', date, error);
    }
    return 'n/a';
};
